/* eslint-disable class-methods-use-this */
import Model from './Model';

export default class CheckOption extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'check_options';
    }

    forWidget() {
        return {
            key: this.key,
            label: this.value,
            value: `/check_options/${this.id}`,
        };
    }
}
